import React, { useState } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import styles from './Image.module.css'

const ImageParagraph = ({ media }) => {
  const { copyright, image, mid, source } = media.entity
  const imageHtmlId = `image-media-${mid}`
  const captionHtmlId = `caption-${imageHtmlId}`
  const sourceHtmlId = `source-${imageHtmlId}`
  const [error, setError] = useState(false)
  const imageErrorURL = '/assets/images/image-not-found.svg'

  const setCopyrightWidth = () => {
    const captionDom = document.getElementById(captionHtmlId)
    if (captionDom) {
      captionDom.style.width = `${document.getElementById(imageHtmlId).width}px`
      captionDom.style.wordBreak = 'break-word'
    }

    const sourceDom = document.getElementById(sourceHtmlId)
    if (sourceDom) {
      sourceDom.style.width = `${document.getElementById(imageHtmlId).width}px`
    }
  }

  return (
    image && (
      <>
        <img
          id={imageHtmlId}
          className={!error ? styles.image : styles.imageError}
          src={!error ? image.url : imageErrorURL}
          title={image.title}
          alt={image.alt}
          onLoad={() => setCopyrightWidth(imageHtmlId, captionHtmlId)}
          onError={() => setError(true)}
        />
        {source && (
          <p id={sourceHtmlId} className={styles.source}>
            Créditos da imagem: {source}
          </p>
        )}
        {copyright && <p className={styles.copyright}>{copyright}</p>}
      </>
    )
  )
}

ImageParagraph.propTypes = {
  media: PropTypes.shape({
    entity: PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }),
  }),
}

const fragments = {
  paragraph: gql`
    fragment ImageParagraphFragment on ParagraphImage {
      id
      media: fieldImage {
        entity {
          mid
          ... on MediaImage {
            image: thumbnail {
              alt
              title
              url
              width
              targetId
            }
            copyright: fieldCopyright
            source: fieldSource
          }
        }
      }
      description: fieldParagraphDescription {
        value
      }
      caption: fieldParagraphCaption {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { ImageParagraph, fragments }
